import type { IconData } from '@stacksjs/iconify-core'

export const buttonPlayCircle: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3Z\"/><path d=\"M15.434 17.315c.352-2.598 2.64-4.064 5.076-3.094c1.534.611 3.547 1.528 6.137 2.904c2.446 1.3 4.378 2.462 5.878 3.446c2.653 1.74 2.653 5.118 0 6.858c-1.5.983-3.432 2.146-5.878 3.446c-2.59 1.375-4.603 2.292-6.137 2.903c-2.436.97-4.724-.495-5.076-3.093A50 50 0 0 1 15 24c0-2.67.195-4.925.434-6.685Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default buttonPlayCircle
